var PushMessageTypes = {
    Odds: "OddsMessage",
    Sogei: "SogeiID",
    UserBets: "UserBets"
};

window.PushMessageTypes = PushMessageTypes;

